import { Command, HttpMethod } from "~/extensions/api";
export class GetDepartmentListCommand extends Command {
    constructor() {
        super(HttpMethod.Get, "common/department");
    }
}
